import { NotFound } from "@components/widgets/ErrorPage";
import { useSearch } from "@tanstack/react-router";
import type React from "react";
import type { ComponentType } from "react";

export interface WithIdProps {
  id: string;
}

export const withId = <T,>(
  Component: ComponentType<React.PropsWithChildren<T & WithIdProps>>,
) => {
  const hocComponent = (props: T) => {
    const rawId = useSearch({
      strict: false,
      select: (search) => (search as Record<string, unknown>).id,
    });

    const value = Array.isArray(rawId) ? rawId[0] : rawId;
    const id =
      value === undefined || value === null ? undefined : String(value);

    if (!id) {
      return <NotFound />;
    }

    return <Component {...props} id={id} />;
  };

  return hocComponent;
};
